import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { RoleStatuses } from "~enums/roleStatuses";
import type { Roles } from "~enums/roles";
import type { RoleResponse } from "~types/role";
import { useApi } from "./useApi";

export type CreateRole = {
  fixtureId: string;
  personId: string;
  role: Roles;
  seasonId: string;
  status: RoleStatuses;
};

export const useCreateRole = (options: UseMutationOptions<RoleResponse, unknown, CreateRole, unknown> = {}) => {
  const request = useApi();
  const { sport, organizationId } = useParams();

  if (!sport || !organizationId) {
    console.error({ sport, organizationId });
    throw new Error("Missing required params");
  }

  return useMutation({
    mutationFn: (body: CreateRole) =>
      request<RoleResponse>(`${sport}/o/${organizationId}/roles`, {
        method: "POST",
        body,
      }),
    ...options,
  });
};
